import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from './services/app.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from './dataServices/userService';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  public isAuthorized = false;
  public currentPageTitle = '';
  public showPolicyDropdown = false;
  public showLogoutButton = false;
  private quotes: any[] = [];

  constructor(
    private appState: AppState,
    private translate: TranslateService,
    private router: Router,
    private userService: UserService,
    private languageService: LanguageService
  ) {
    // Language initialization is now handled by LanguageService
    // Subscribe to language changes to keep translations in sync
    this.languageService.currentLanguage$.subscribe(language => {
      this.translate.use(language.code);
    });
    
    this.appState.user.subscribe((u) => {
      this.isAuthorized = u?.status === 'active';
      // Update logout button visibility whenever authorization status changes
      this.updateLogoutButtonVisibility(this.router.url);
      // When user is authorized, get quotes
      if (this.isAuthorized) {
        this.userService.getQuotes().subscribe(quotes => {
          this.quotes = quotes || [];
          this.updatePolicyDropdownVisibility();
        });
      }
    });

    // Track route changes for page titles
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updatePageTitle(event.url);
      this.updatePolicyDropdownVisibility();
      this.updateLogoutButtonVisibility(event.url);
    });
  }


  public logout() {
    this.appState.logOut();
  }

  private updatePageTitle(url: string): void {
    const titleMap: { [key: string]: string } = {
      '/coverage': 'common.home',
      '/verification-tractors': 'verificationTractors.title',
      '/verification-drivers': 'verificationDrivers.title',
      '/coverage-proposal': 'coverageProposal.titleActive',
      '/verification': 'verification.title',
      '/documents': 'documents.title',
      '/analytics': 'analytics.title'
    };

    const matchedRoute = Object.keys(titleMap).find(route => url.includes(route));
    this.currentPageTitle = matchedRoute ? titleMap[matchedRoute] : '';
  }

  private updatePolicyDropdownVisibility(): void {
    // Show policy dropdown on pages where sidebar is shown and when there are multiple quotes
    const showPolicyRoutes = ['/coverage', '/verification-tractors', '/verification-drivers', 
                             '/coverage-proposal', '/verification', '/documents', '/analytics'];
    const onPolicyRoute = showPolicyRoutes.some(route => this.router.url.includes(route));
    this.showPolicyDropdown = onPolicyRoute && this.quotes.length > 1;
  }

  private updateLogoutButtonVisibility(url: string): void {
    // Hide logout button on login-related pages
    const hideLogoutRoutes = ['/login', '/forgot-password', '/reset-password'];
    const onHideLogoutRoute = hideLogoutRoutes.some(route => url.includes(route));
    this.showLogoutButton = this.isAuthorized && !onHideLogoutRoute;
  }
}
